import React from 'react';
import './promptwithicon.css';
import { useRef, useState, useEffect } from 'react';
import StatusContext from '../../../contexts/StatusContext'
import CircularProgress from '@mui/material/CircularProgress';
import UploadedFile from './UploadedFile';


import { ArrowForwardIconGray } from '../customicons/ArrowForwardIconGray';


export const PromptWithIcon = ({ prompt, setPrompt, onSubmit, placeholdertext,
                                 attachedFiles, 
                                 deleteFile, 
                                 clearPrompt}) => {

  const divIconRef = useRef(null);
  const myTextareaRef = useRef(null);
  const [iconPosition, setIconPosition] = useState({ x: 0, y: 10 });



  let {
    isLoading,
    isMobile, 
  } = React.useContext(StatusContext);


  const handleChange = (event) => {
  
    setPrompt(event.target.value)
    // Use setTimeout to ensure state is updated before resizing
    setTimeout(() => {
      resizeTextarea();
    }, 100);

  }

  const handleKeyDown = (event) => {
    //desktop: enter key will submit, Shift+Enter will insert a new line
    //mobile: enter key will add a new line, user has to click on icon to submit
    if ( !isMobile() )
    {
      
      if (event.key === 'Enter' && !event.shiftKey)
        { 
          event.preventDefault(); 
          // Prevent newline handleSubmit();
          handleIconClick()
          // Shift+Enter will fall through and add a new line };
      }

    }
  }

  const handleIconClick = () => {
    
    onSubmit()
    
    if (clearPrompt === true)
    {
        setTimeout(() => {
          restoreTextarea();
        }, 100); // Allows React to process the state update before restoring
    }
    
  }

  const restoreTextarea = () => {

    if (myTextareaRef)
    {
    myTextareaRef.current.style.height = 'auto';
  
    const iconY = 10
    setIconPosition({ x: iconPosition.x, y: iconY });
    setPrompt('')
    }

  }

  const resizeTextarea = React.useCallback(() => {

    if (myTextareaRef)
    {
      myTextareaRef.current.style.height = 'auto';
      myTextareaRef.current.style.height = Math.min(myTextareaRef.current.scrollHeight, 500) + 'px'; // Limit height to 100px
  
      const lineHeight = parseInt(getComputedStyle(myTextareaRef.current)['line-height']);
      const height = myTextareaRef.current.clientHeight;

      const iconY = height - lineHeight - 10
      setIconPosition({ x: iconPosition.x, y: iconY });
    }


  },[iconPosition.x])

  

  useEffect(() => {
    // Call resize when component mounts or when prompt changes
      resizeTextarea();
  }, [prompt, resizeTextarea])


 
  return (
    <div>
   
      <div className='uploadedFiles flex-container-wrap'>
        {attachedFiles.map((file, index) => ( 
          <UploadedFile key={index} filename={file.name} filesize={file.sizeText} deleteFile={() => deleteFile(index)} /> ))}
       </div>
    
    
    <div className="containerPromptWithIcon">
      <textarea ref={myTextareaRef}  className="promptwithiconTextarea"
        placeholder={placeholdertext}
        value={prompt}
        rows={1}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={resizeTextarea}
        onBlur={resizeTextarea} 
      />

      {isLoading ?
        (<div className='wait-icon'>
          <CircularProgress style={{ color: 'maroon' }}/>
        </div>
        )
        :
        (
          <div className="divIcon">
            <div ref={divIconRef}
              id="divIcon"
              name='icon'
              style={{ position: 'relative', left: iconPosition.x, top: iconPosition.y }}>

              <ArrowForwardIconGray  onClick={handleIconClick} />

            </div>
          </div>
        )
      }

    </div>

    </div>
  );
};

PromptWithIcon.defaultProps = {
  attachedFiles: [],
  filesize:'',
  deleteFile:  (file) => console.log(`Default delete for file: ${file}`),
  clearPrompt: true,

}
